import { AlarmColorType, AlarmDetailsExpandedState, AlarmModel, AlarmNote, AlarmNoteForAcknowledge } from '../../model/AlarmModel';
import { AlarmActionType } from './actionsTypes';

type SetShowAlarmDetails = {
	type: AlarmActionType.SET_SHOW_ALARM_DETAILS;
	payload: {
		alarmModel: Partial<AlarmModel>;
		showAlarmDetailsExpandedState: AlarmDetailsExpandedState;
	};
};

type SetShowAlarmCredentials = {
	type: AlarmActionType.SET_SHOW_ALARM_CREDENTIALS;
	payload: { showCredentials: boolean; credentialsIds: number[] };
};

type SetShowAlarmAddOperatorNote = {
	type: AlarmActionType.SET_SHOW_ALARM_ADD_OPERATOR_NOTE;
	payload: boolean;
};

type SetAlarmNoteForAcknowledge = {
	type: AlarmActionType.SET_ALARM_NOTE_FOR_ACKNOWLEDGE;
	payload: AlarmNoteForAcknowledge;
};

type SetOperatorNotesAdded = {
	type: AlarmActionType.SET_OPERATOR_NOTES_ADDED;
	payload: AlarmNote[];
};

type SetAlarmColors = {
	type: AlarmActionType.SET_ALARM_COLORS;
	payload: Record<AlarmColorType, string>;
};

//Union Action Types
export type AlarmAction =
	| SetShowAlarmDetails
	| SetShowAlarmCredentials
	| SetShowAlarmAddOperatorNote
	| SetAlarmNoteForAcknowledge
	| SetAlarmColors
	| SetOperatorNotesAdded;

//Action Creators

//Export Action
export const setShowAlarmDetails = (payload: {
	alarmModel: Partial<AlarmModel>;
	showAlarmDetailsExpandedState: AlarmDetailsExpandedState;
}): SetShowAlarmDetails => {
	return {
		type: AlarmActionType.SET_SHOW_ALARM_DETAILS,
		payload,
	};
};

export const setShowAlarmCredentials = (payload: { showCredentials: boolean; credentialsIds: number[] }): SetShowAlarmCredentials => {
	return {
		type: AlarmActionType.SET_SHOW_ALARM_CREDENTIALS,
		payload,
	};
};

export const setShowAlarmAddOperatorNote = (payload: boolean): SetShowAlarmAddOperatorNote => {
	return {
		type: AlarmActionType.SET_SHOW_ALARM_ADD_OPERATOR_NOTE,
		payload,
	};
};

export const setAlarmNoteForAcknowledge = (payload: AlarmNoteForAcknowledge): SetAlarmNoteForAcknowledge => {
	return {
		type: AlarmActionType.SET_ALARM_NOTE_FOR_ACKNOWLEDGE,
		payload,
	};
};

export const setOperatorNotesAdded = (payload: AlarmNote[]): SetOperatorNotesAdded => {
	return {
		type: AlarmActionType.SET_OPERATOR_NOTES_ADDED,
		payload,
	};
};

export const setAlarmColors = (payload: Record<AlarmColorType, string>): SetAlarmColors => ({
	type: AlarmActionType.SET_ALARM_COLORS,
	payload,
});
